import React from "react";
import me from '../../assests/images/me.webp'

function Logo(){
    return(
        <img src={me}></img>
    )
}

export default Logo